import Text from '../../../../atoms/Text';
import Button from '../../../../molecules/Button';
import { ReactComponent as SkeletonActive } from '../../images/skeleton.svg';

interface IDeployingProps {
  scroll: boolean;
}

const Deploying = ({ scroll }: IDeployingProps) => {
  return (
    <>
      {scroll ? null : (
        <div className='skeleton'>
          <SkeletonActive />
        </div>
      )}
      <div className='placeholder__text'>
        <Text size={12}>
          In order to create limit orders we need to deploy a proxy contract
          associated to your wallet
        </Text>
      </div>
      <div className='row'>
        <Button
          action={() => undefined}
          size='m'
          variant='primary'
          text='Deploying...'
        />
      </div>
    </>
  );
};

export default Deploying;
